import { CORPORATE_CLIENT_COUNTRIES } from 'constants/corporateClients';

// Single source of truth for a corporation's country -> currency. The symbol (shown beside
// amounts) and the ISO code (expected by the shared formatCurrency helper in
// src/pages/InvoicesAndStatements/helper) live together so the two can't drift apart.
const COUNTRY_CURRENCY = {
  [CORPORATE_CLIENT_COUNTRIES.US]: { code: 'USD', symbol: '$' },
  [CORPORATE_CLIENT_COUNTRIES.CA]: { code: 'CAD', symbol: '$' },
  [CORPORATE_CLIENT_COUNTRIES.GB]: { code: 'GBP', symbol: '£' },
  [CORPORATE_CLIENT_COUNTRIES.FR]: { code: 'EUR', symbol: '€' },
  [CORPORATE_CLIENT_COUNTRIES.DE]: { code: 'EUR', symbol: '€' },
  [CORPORATE_CLIENT_COUNTRIES.CH]: { code: 'CHF', symbol: 'CHF' },
};

// GB stands in for an unknown or missing country.
const DEFAULT_CURRENCY = COUNTRY_CURRENCY[CORPORATE_CLIENT_COUNTRIES.GB];

export const getCurrency = country => COUNTRY_CURRENCY[country] || DEFAULT_CURRENCY;

export const getCurrencySymbol = country => getCurrency(country).symbol;

export const getCurrencyCode = country => getCurrency(country).code;
